import { PromptQuestionCircleFill } from "@/Icons";
import { Tooltip } from "@ad/anq-ui";
import { TooltipPlacement } from "@ad/anq-ui/lib/tooltip";

type Props = {
  title: React.ReactNode;
  placement?: TooltipPlacement;
};

const QuestionNotice: React.FC<Props> = (props) => {
  const { title, placement } = props;
  return (
    <Tooltip title={title || "-"} placement={placement || "top"}>
      <PromptQuestionCircleFill className="cursor-pointer text-question" />
    </Tooltip>
  );
};

export { QuestionNotice };
